import React from 'react'

 const Cotton = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="68.578" height="56.881" viewBox="0 0 68.578 56.881">
    <g id="Group_18438" data-name="Group 18438" transform="translate(-24.465 -475.369)">
      <g id="_ÎÓÈ_2_2_" data-name="—ÎÓÈ_2_2_">
        <g id="Group_18388" data-name="Group 18388">
          <g id="Group_18360" data-name="Group 18360">
            <rect id="Rectangle_149122" data-name="Rectangle 149122" width="7.697" height="35.614" transform="translate(58.754 480.268)" fill="#f0f0f0"/>
          </g>
          <g id="Group_18362" data-name="Group 18362">
            <g id="Group_18361" data-name="Group 18361">
              <path id="Path_19374" data-name="Path 19374" d="M58.754,532.25s3.939-6.109,4.9-9.1.138-7.271.138-7.271l-5.036-2.876Z" fill="#abde82"/>
            </g>
          </g>
          <g id="Group_18364" data-name="Group 18364">
            <g id="Group_18363" data-name="Group 18363">
              <path id="Path_19375" data-name="Path 19375" d="M86.045,523.153s-5.6-1.4-7.7,1.4-12.025,3.509-11.9-.874-6.769-11.2-6.769-11.2l6.769-2.022s9.487,3.037,13.3,7.7S86.045,523.153,86.045,523.153Z" fill="#9fd174"/>
            </g>
          </g>
          <g id="Group_18366" data-name="Group 18366">
            <g id="Group_18365" data-name="Group 18365">
              <path id="Path_19376" data-name="Path 19376" d="M93.043,506.708s0,13.449-9.8,11.448a51.35,51.35,0,0,1-15.6-5.622s.206-5.8.906-7.786,14.19.211,17.241,1.96S93.043,506.708,93.043,506.708Z" fill="#a3d875"/>
            </g>
          </g>
          <g id="Group_18368" data-name="Group 18368">
            <g id="Group_18367" data-name="Group 18367">
              <path id="Path_19377" data-name="Path 19377" d="M72.863,507.758s17.031-.35,17.731-7-4.549-15.594-4.549-15.594-8.747-6.1-11.9,10c-1.574,8.047-1.088,8.31-.132,6.429s2.378-5.9,2.679-6.429c.6-1.05,9.144-15.045,3.649-17.32s-13.893-6.473-13.893,7.523,2.1,2.1,2.1,2.1Z" fill="#94c95d"/>
            </g>
          </g>
          <g id="Group_18370" data-name="Group 18370">
            <g id="Group_18369" data-name="Group 18369">
              <path id="Path_19378" data-name="Path 19378" d="M70.65,504.784a7.7,7.7,0,1,0,7.7-7.7A7.7,7.7,0,0,0,70.65,504.784Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18372" data-name="Group 18372">
            <g id="Group_18371" data-name="Group 18371">
              <path id="Path_19379" data-name="Path 19379" d="M61.553,497.086a7.7,7.7,0,1,0,7.7-7.7A7.7,7.7,0,0,0,61.553,497.086Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18374" data-name="Group 18374">
            <g id="Group_18373" data-name="Group 18373">
              <path id="Path_19380" data-name="Path 19380" d="M70.65,495.162a7.7,7.7,0,1,0,7.7-7.7A7.7,7.7,0,0,0,70.65,495.162Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18376" data-name="Group 18376">
            <g id="Group_18375" data-name="Group 18375">
              <path id="Path_19381" data-name="Path 19381" d="M61.553,485.54a7.7,7.7,0,1,0,7.7-7.7A7.7,7.7,0,0,0,61.553,485.54Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18378" data-name="Group 18378">
            <g id="Group_18377" data-name="Group 18377">
              <path id="Path_19382" data-name="Path 19382" d="M61.553,510.459a7.7,7.7,0,1,0,7.7-7.7A7.7,7.7,0,0,0,61.553,510.459Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18380" data-name="Group 18380">
            <g id="Group_18379" data-name="Group 18379">
              <path id="Path_19383" data-name="Path 19383" d="M58.845,514.4a4.9,4.9,0,1,0,3.848-3.848A4.907,4.907,0,0,0,58.845,514.4Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18382" data-name="Group 18382">
            <g id="Group_18381" data-name="Group 18381">
              <path id="Path_19384" data-name="Path 19384" d="M58.845,479.309a4.9,4.9,0,1,0,3.848-3.849A4.906,4.906,0,0,0,58.845,479.309Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18384" data-name="Group 18384">
            <g id="Group_18383" data-name="Group 18383">
              <path id="Path_19385" data-name="Path 19385" d="M72.14,486.506a4.9,4.9,0,1,0,3.849-3.849A4.907,4.907,0,0,0,72.14,486.506Z" fill="#dee2d9"/>
            </g>
          </g>
          <g id="Group_18385" data-name="Group 18385">
            <path id="Path_19386" data-name="Path 19386" d="M59.8,502.761a7.7,7.7,0,1,0,7.7-7.7A7.7,7.7,0,0,0,59.8,502.761Z" fill="#f0f0f0"/>
          </g>
          <g id="Group_18386" data-name="Group 18386">
            <circle id="Ellipse_272" data-name="Ellipse 272" cx="4.898" cy="4.898" r="4.898" transform="translate(69.045 490.264)" fill="#f0f0f0"/>
          </g>
          <g id="Group_18387" data-name="Group 18387">
            <path id="Path_19387" data-name="Path 19387" d="M59.757,491.6a5.409,5.409,0,1,0,5.41-5.41A5.41,5.41,0,0,0,59.757,491.6Z" fill="#f0f0f0"/>
          </g>
        </g>
        <g id="Group_18417" data-name="Group 18417">
          <g id="Group_18389" data-name="Group 18389">
            <rect id="Rectangle_149123" data-name="Rectangle 149123" width="7.698" height="35.614" transform="translate(51.056 480.268)" fill="#f0f0f0"/>
          </g>
          <g id="Group_18391" data-name="Group 18391">
            <g id="Group_18390" data-name="Group 18390">
              <path id="Path_19388" data-name="Path 19388" d="M58.754,532.25s-3.94-6.109-4.9-9.1-.137-7.271-.137-7.271l5.036-2.876Z" fill="#c5f49d"/>
            </g>
          </g>
          <g id="Group_18393" data-name="Group 18393">
            <g id="Group_18392" data-name="Group 18392">
              <path id="Path_19389" data-name="Path 19389" d="M31.462,523.153s5.6-1.4,7.7,1.4,12.024,3.509,11.9-.874,6.769-11.2,6.769-11.2l-6.769-2.022s-9.486,3.037-13.3,7.7S31.462,523.153,31.462,523.153Z" fill="#bde897"/>
            </g>
          </g>
          <g id="Group_18395" data-name="Group 18395">
            <g id="Group_18394" data-name="Group 18394">
              <path id="Path_19390" data-name="Path 19390" d="M24.465,506.708s0,13.449,9.8,11.448a51.35,51.35,0,0,0,15.6-5.622s-.206-5.8-.9-7.786-14.191.211-17.242,1.96S24.465,506.708,24.465,506.708Z" fill="#abde82"/>
            </g>
          </g>
          <g id="Group_18397" data-name="Group 18397">
            <g id="Group_18396" data-name="Group 18396">
              <path id="Path_19391" data-name="Path 19391" d="M44.644,507.758s-17.031-.35-17.73-7,4.548-15.594,4.548-15.594,8.748-6.1,11.9,10c1.574,8.047,1.088,8.31.133,6.429s-2.379-5.9-2.68-6.429c-.6-1.05-9.144-15.045-3.649-17.32s13.893-6.473,13.893,7.523-2.1,2.1-2.1,2.1Z" fill="#9ad367"/>
            </g>
          </g>
          <g id="Group_18399" data-name="Group 18399">
            <g id="Group_18398" data-name="Group 18398">
              <path id="Path_19392" data-name="Path 19392" d="M46.857,504.784a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,46.857,504.784Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18401" data-name="Group 18401">
            <g id="Group_18400" data-name="Group 18400">
              <path id="Path_19393" data-name="Path 19393" d="M55.954,497.086a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,55.954,497.086Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18403" data-name="Group 18403">
            <g id="Group_18402" data-name="Group 18402">
              <path id="Path_19394" data-name="Path 19394" d="M46.857,495.162a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,46.857,495.162Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18405" data-name="Group 18405">
            <g id="Group_18404" data-name="Group 18404">
              <path id="Path_19395" data-name="Path 19395" d="M55.954,485.54a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,55.954,485.54Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18407" data-name="Group 18407">
            <g id="Group_18406" data-name="Group 18406">
              <path id="Path_19396" data-name="Path 19396" d="M55.954,510.459a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,55.954,510.459Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18409" data-name="Group 18409">
            <g id="Group_18408" data-name="Group 18408">
              <path id="Path_19397" data-name="Path 19397" d="M58.662,514.4a4.9,4.9,0,1,1-3.848-3.848A4.907,4.907,0,0,1,58.662,514.4Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18411" data-name="Group 18411">
            <g id="Group_18410" data-name="Group 18410">
              <path id="Path_19398" data-name="Path 19398" d="M58.662,479.309a4.9,4.9,0,1,1-3.848-3.849A4.906,4.906,0,0,1,58.662,479.309Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18413" data-name="Group 18413">
            <g id="Group_18412" data-name="Group 18412">
              <path id="Path_19399" data-name="Path 19399" d="M45.367,486.506a4.9,4.9,0,1,1-3.849-3.849A4.906,4.906,0,0,1,45.367,486.506Z" fill="#f0f0f0"/>
            </g>
          </g>
          <g id="Group_18414" data-name="Group 18414">
            <path id="Path_19400" data-name="Path 19400" d="M57.7,502.761a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,57.7,502.761Z" fill="#f9f9f9"/>
          </g>
          <g id="Group_18415" data-name="Group 18415">
            <circle id="Ellipse_273" data-name="Ellipse 273" cx="4.898" cy="4.898" r="4.898" transform="translate(38.666 490.264)" fill="#f9f9f9"/>
          </g>
          <g id="Group_18416" data-name="Group 18416">
            <path id="Path_19401" data-name="Path 19401" d="M57.75,491.6a5.41,5.41,0,1,1-5.41-5.41A5.41,5.41,0,0,1,57.75,491.6Z" fill="#f9f9f9"/>
          </g>
        </g>
      </g>
      <g id="Group_18418" data-name="Group 18418">
        <path id="Path_19402" data-name="Path 19402" d="M59.912,490.436a4.411,4.411,0,0,0-1.158-8.67v8.5A4.386,4.386,0,0,1,59.912,490.436Z" fill="#f0f0f0"/>
      </g>
      <g id="Group_18419" data-name="Group 18419">
        <path id="Path_19403" data-name="Path 19403" d="M58.754,481.766a4.411,4.411,0,0,0-1.159,8.67,4.387,4.387,0,0,1,1.159-.172Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18420" data-name="Group 18420">
        <path id="Path_19404" data-name="Path 19404" d="M58.754,494.422a8.386,8.386,0,0,1,4.318,1.2,4.385,4.385,0,0,0-3.16-5.184,4.347,4.347,0,0,1-1.158.173Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18421" data-name="Group 18421">
        <path id="Path_19405" data-name="Path 19405" d="M58.754,490.609a4.348,4.348,0,0,1-1.159-.173,4.38,4.38,0,0,0-3.159,5.184,8.381,8.381,0,0,1,4.318-1.2Z" fill="#fff"/>
      </g>
      <g id="Group_18422" data-name="Group 18422">
        <path id="Path_19406" data-name="Path 19406" d="M58.754,490.264a4.387,4.387,0,0,0-1.159.172,4.348,4.348,0,0,0,1.159.173Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18423" data-name="Group 18423">
        <path id="Path_19407" data-name="Path 19407" d="M58.754,490.609a4.347,4.347,0,0,0,1.158-.173,4.386,4.386,0,0,0-1.158-.172Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18424" data-name="Group 18424">
        <path id="Path_19408" data-name="Path 19408" d="M58.754,516.006a4.371,4.371,0,0,0,4.174-5.82,8.383,8.383,0,0,1-4.174,1.111Z" fill="#f0f0f0"/>
      </g>
      <g id="Group_18425" data-name="Group 18425">
        <path id="Path_19409" data-name="Path 19409" d="M54.579,510.186a4.371,4.371,0,0,0,4.175,5.82V511.3A8.386,8.386,0,0,1,54.579,510.186Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18426" data-name="Group 18426">
        <path id="Path_19410" data-name="Path 19410" d="M67.192,502.859a8.426,8.426,0,0,0-4.12-7.239,4.421,4.421,0,0,1-4.318,3.487v8.056a4.406,4.406,0,0,1,4.174,3.023A8.431,8.431,0,0,0,67.192,502.859Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18427" data-name="Group 18427">
        <path id="Path_19411" data-name="Path 19411" d="M58.754,507.163v-8.056a4.42,4.42,0,0,1-4.318-3.487,8.423,8.423,0,0,0,.143,14.566A4.408,4.408,0,0,1,58.754,507.163Z" fill="#fff"/>
      </g>
      <g id="Group_18428" data-name="Group 18428">
        <path id="Path_19412" data-name="Path 19412" d="M58.754,499.107a4.421,4.421,0,0,0,4.318-3.487,8.386,8.386,0,0,0-4.318-1.2Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18429" data-name="Group 18429">
        <path id="Path_19413" data-name="Path 19413" d="M58.754,499.107v-4.685a8.381,8.381,0,0,0-4.318,1.2A4.42,4.42,0,0,0,58.754,499.107Z" fill="#fff"/>
      </g>
      <g id="Group_18430" data-name="Group 18430">
        <path id="Path_19414" data-name="Path 19414" d="M58.754,507.163V511.3a8.383,8.383,0,0,0,4.174-1.111A4.406,4.406,0,0,0,58.754,507.163Z" fill="#f9f9f9"/>
      </g>
      <g id="Group_18431" data-name="Group 18431">
        <path id="Path_19415" data-name="Path 19415" d="M58.754,507.163a4.408,4.408,0,0,0-4.175,3.023,8.386,8.386,0,0,0,4.175,1.111Z" fill="#fff"/>
      </g>
      <g id="Group_18432" data-name="Group 18432">
        <path id="Path_19416" data-name="Path 19416" d="M56.666,494.422a3.33,3.33,0,1,1-3.33-3.331A3.329,3.329,0,0,1,56.666,494.422Z" fill="#fff"/>
      </g>
      <g id="Group_18433" data-name="Group 18433">
        <circle id="Ellipse_274" data-name="Ellipse 274" cx="3.33" cy="3.33" r="3.33" transform="translate(47.726 495.777)" fill="#fff"/>
      </g>
      <g id="Group_18434" data-name="Group 18434">
        <circle id="Ellipse_275" data-name="Ellipse 275" cx="3.372" cy="3.372" r="3.372" transform="translate(62.495 492.363)" fill="#f9f9f9"/>
      </g>
      <g id="Group_18435" data-name="Group 18435">
        <circle id="Ellipse_276" data-name="Ellipse 276" cx="3.372" cy="3.372" r="3.372" transform="translate(62.495 498.075)" fill="#f9f9f9"/>
      </g>
      <g id="Group_18436" data-name="Group 18436">
        <circle id="Ellipse_277" data-name="Ellipse 277" cx="3.372" cy="3.372" r="3.372" transform="translate(61.795 501.447)" fill="#f9f9f9"/>
      </g>
      <g id="Group_18437" data-name="Group 18437">
        <path id="Path_19417" data-name="Path 19417" d="M55.65,503.3A3.374,3.374,0,1,1,53,500.653,3.378,3.378,0,0,1,55.65,503.3Z" fill="#fff"/>
      </g>
    </g>
  </svg>

  );
};
export default Cotton
